import React, { useEffect, useState } from "react";
import HashLoader from "react-spinners/HashLoader";
import {useParams} from "react-router-dom";
import { isMobile } from "react-device-detect";
import * as qrcode from "qrcode";
import axios from "axios";
import environment from "../environment";

export default function ShareAppPage() {
	const [qrCode, setQrCode] = useState(null);
	const { code } = useParams();

	function navigate(path) {
		window.location.replace(path);
	}

	const getLink = async () => {
		let url = "";

		const response = await axios.post(`${environment.baseUrl}shareLink`, {
			partner: code || undefined
		});

		if (response?.data) {
			url = response.data;
		} else {
			url = `https://app.adjust.com/qdsjk20?deep_link=at.taxefy.app%3A%2F%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3D${code}&fallback=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3D${code}&redirect_macos=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3D${code}&label=${code}`;
		}

		if (!isMobile) {
			// Generate QR code for the deeplink if not mobile
			const temp = await qrcode.toDataURL(url);
			setQrCode(temp);
		} else {
			// Redirect mobile users directly
			navigate(url);
		}
	};

	useEffect(() => {
		getLink();
	}, []);

	return (
		<div style={{textAlign: "center", marginTop: "20vh"}}>
			{isMobile &&
				<div style={{
					width: "100vw",
					height: "100vh",
					display: "flex",
					justifyContent: "center",
					alignItems: "center"
				}}>
					<HashLoader color="gray" size={55}/>
				</div>
			}
			{!isMobile && (
				<div>
					<h1 style={{color: "rgba(0, 190, 170, 1)"}}>
						Weiter mit dem Handy - Scanne den QR Code
					</h1>
					<img src={qrCode} style={{ margin: "20px", width: "20%" }} alt="QR Code" />
				</div>
			)}
		</div>
	);
}
